import { HourglassEmpty } from '@mui/icons-material';
import { Box, Typography, Paper, useTheme } from '@mui/material';
import { ReactNode } from 'react';

interface NoDataInfoProps {
  title: string;
  emptyMessage: string;
  icon: ReactNode;
  iconBgColor?: string; // optional override for background color
}

export const NoDataInfo = ({ title, emptyMessage, icon, iconBgColor }: NoDataInfoProps) => {
  const theme = useTheme();
  const { palette } = theme;
  const isLight = palette.mode === 'light';

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', gap: 1 }} gutterBottom>
        {icon}
        {title}
      </Typography>

      <Paper
        variant="outlined"
        sx={{
          p: 4,
          textAlign: 'center',
          borderRadius: 1,
          boxShadow: '0 0 0 1px rgba(0,0,0,0.08)',
          bgcolor: isLight ? palette.grey[50] : palette.background.paper,
        }}
      >
        <Box
          sx={{
            width: 50,
            height: 50,
            mx: 'auto',
            mb: 2,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'gray',
            color: palette.primary.contrastText,
            boxShadow: 1,
          }}
        >
          <HourglassEmpty />
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
          Nothing to show yet
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {emptyMessage}
        </Typography>
      </Paper>
    </Box>
  );
};

export default NoDataInfo;
